import { render, staticRenderFns } from "./AddExistingCourseware.vue?vue&type=template&id=7826e818"
import script from "./AddExistingCourseware.vue?vue&type=script&lang=js"
export * from "./AddExistingCourseware.vue?vue&type=script&lang=js"
import style0 from "./AddExistingCourseware.vue?vue&type=style&index=0&id=7826e818&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports